import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { LIST_QUERY_KEY } from "@/utils/query";

import { fetchCountriesListData } from "./countriesApi";

export const useCountries = () =>
  useQuery({
    queryKey: [MODULE_NAMES.COUNTRIES, LIST_QUERY_KEY],
    queryFn: async () => {
      const { data = [] } = await fetchCountriesListData();
      return {
        countriesList: data,
        countriesObject: data.reduce<Record<string, string>>((acc, country) => {
          acc[country.code] = country.name ?? country.code;
          return acc;
        }, {}),
      };
    },
    staleTime: Infinity,
  });
